import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import UserService from '../../../Services/userService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import FreelancerInvoiceStatusEnum from '../../../Enums/FreelancerInvoiceStatusEnum';
import SearchParamsBase from '../../../Elements/SearchParamsBase';
import FeeTypesEnum from '../../../Enums/FeeTypesEnum';

export default class FreelancerInvoicesSearchParams extends SearchParamsBase {
  initialize() {
    this.FreelancerInvoiceId = '';
    this.FreelancerUserIdOrName = '';
    this.OfficeId = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.Status = '';
    this.Yrmo = '';
    this.Type = '';
    this.FreelancerPaymentExportId = '';
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'FreelancerInvoiceId', label: 'Invoice Id', className: 'col-3', type: InputTypesEnum.Number },
    {
      fieldName: 'FreelancerUserIdOrName',
      label: 'Vendor (Id or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'OfficeId',
      label: 'Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupSelect,
      roleKey: 'Freelancer_inputfield_VendorAdminFinanceAdmin',
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: FreelancerInvoicesSearchParams.getStatusSelectOptions(),
    },
    { fieldName: 'Yrmo', label: 'Revenue Period', className: 'col-4', type: InputTypesEnum.Number },
    {
      fieldName: 'FreelancerPaymentExportId',
      label: 'Payment Export Id',
      className: 'col-4',
      type: InputTypesEnum.Number,
    },
    {
      fieldName: 'Type',
      label: 'Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: FreelancerInvoicesSearchParams.getSelectValuesForFeeType(),
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'FreelancerInvoicesSearchParams';

  //---------------------------

  static getSelectValuesForFeeType() {
    return selectHelper.generateSelectValues([
      '',
      FeeTypesEnum.RM,
      FeeTypesEnum.DQ,
      FeeTypesEnum.KAM,
      FeeTypesEnum.BD,
      FeeTypesEnum.BI,
      FeeTypesEnum.IT,
      FeeTypesEnum.HR,
      FeeTypesEnum.Marketing,
      FeeTypesEnum.Finance,
      FeeTypesEnum.FieldworkPartner,
    ]);
  }

  static getStatusSelectOptions() {
    return [
      { label: '', value: '', disabled: false },
      { label: 'Created', value: FreelancerInvoiceStatusEnum.Created, disabled: false },
      { label: 'Finalized', value: FreelancerInvoiceStatusEnum.Finalized, disabled: false },
      { label: 'File Uploaded', value: FreelancerInvoiceStatusEnum.FileUploaded, disabled: false },
      { label: 'Invoice Dismissed', value: FreelancerInvoiceStatusEnum.InvoiceDismissed, disabled: false },
      { label: 'Invoice Approved', value: FreelancerInvoiceStatusEnum.InvoiceApproved, disabled: false },
      { label: 'Linked To Export', value: FreelancerInvoiceStatusEnum.LinkedToExport, disabled: false },
      { label: 'To Be Sent To Tipalti', value: FreelancerInvoiceStatusEnum.ToBeSentToTipalti, disabled: false },
      { label: 'Deleted At Tipalti', value: FreelancerInvoiceStatusEnum.DeletedAtTipalti, disabled: false },
      { label: 'Error At Tipalti', value: FreelancerInvoiceStatusEnum.ErrorAtTipalti, disabled: false },
      { label: 'Sent To Tipalti', value: FreelancerInvoiceStatusEnum.SentToTipalti, disabled: false },
      { label: 'Paid', value: FreelancerInvoiceStatusEnum.Paid, disabled: false },
      {
        label: 'ManuallyPaidOutsideOfTipalti',
        value: FreelancerInvoiceStatusEnum.ManuallyPaidOutsideOfTipalti,
        disabled: false,
      },
    ];
  }
}
